import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { ISearchTransactionResponse } from '../interfaces/searchTransactionResponse';
import { ScoringResponse } from '../interfaces/scoring';

@Injectable({
  providedIn: 'root',
})
export class StoreService {
  searchTransactionResponse$: BehaviorSubject<ISearchTransactionResponse | null> =
    new BehaviorSubject<ISearchTransactionResponse | null>(null);

  onlySignOperation: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(
    false,
  );

  transactionId$: BehaviorSubject<string | null> = new BehaviorSubject<
    string | null
  >(null);

  scoringResponse$: BehaviorSubject<ScoringResponse | null> =
    new BehaviorSubject<ScoringResponse | null>(null);

  logoImageUrl$: BehaviorSubject<string> = new BehaviorSubject<string>(
    '../../../assets/obd-logo.svg',
  );

  constructor() {}
}
